





























import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
import '../assets/css/Calendar.scss';
import { CommonUtils } from '@/util/commonUtils';
import { DateUtils } from '@/util/dateUtils';
import { MemberProfile } from '@/types/response';
@Component({
    data() {
        return {
            masks: {
                weekdays: 'WWW',
            },
            attributes: [
                {
                    key: '',
                    customData: {
                        title: '',
                        class: '',
                    },
                    highlight: {
                        color: 'purple',
                        fillMode: 'outline',
                        contentClass: 'italic',
                    },
                    dates: new Date(),
                },
            ],
        };
    },
})
export default class Calendar extends Vue {
    public mounted() {
        this.getRequests('', 0);
    }
    private showViewRequestModal(id: string) {
        this.$router.push({ path: `${MedTransGoConstants.URL_CALENDAR}/${id}` });
    }
    private async getRequests(searchString?: string, start?: number) {
        const response = await ObjectFactory.getRequestService().getRequests({
            baseURL: this.$store.state.serverUrl,
            start,
            limit: MedTransGoConstants.DB_QUERY_MAX_RESULT,
        });
        if (response.success && response.data) {
            response.data.forEach((element) => {
                element.appointment.timestamp = Date.parse(DateUtils.formatDate(element.appointment.timestamp,
                DateUtils.FORMAT_DATETIME_AM_PM)) as any;
                const userTimeZone = DateUtils.getLocalTimezone();
                const formattedDate = this.convertTimestampToTimeZone(element.appointment.timestamp, userTimeZone);
                const timestamp = DateUtils.formatDate(element.appointment.timestamp,
                'hh:mm a') as any;
                if (!['Pending', 'Requires Approval'].includes(element.status)) {
                    if (element.transportRequest && element.status === 'Confirmed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: ${element.transportRequest.vehicleType} request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-white',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                    if (element.transportRequest && element.status === 'Completed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: ${element.transportRequest.vehicleType} request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-green',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                    if (element.deliveryRequest && element.status === 'Confirmed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: Delivery request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-pink',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                    if (element.deliveryRequest && element.status === 'Completed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: Delivery request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-green',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                    if (element.interpreterRequest && element.status === 'Confirmed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: ${element.interpreterRequest.language} request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-yellow',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                    if (element.interpreterRequest && element.status === 'Completed') {
                        const attributes = {
                            key: element.id,
                            customData: {
                                title: `${timestamp}: ${element.interpreterRequest.language} request for ${element.appointment.patient.fullName}`,
                                class: 'bg-blue-500 text-green',
                            },
                            dates: formattedDate,
                        };
                        this.$data.attributes.push(attributes);
                    }
                }
            });
        } else {
            CommonUtils.showError(response);
        }
    }

    private convertTimestampToTimeZone(timestamp: number, userTimeZone: string) {
        const date = new Date(timestamp);
        const options: Intl.DateTimeFormatOptions = {
            timeZone: userTimeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        };
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
        return formattedDate;
    }

}
